import MainView from '../components/Layout/MainView.vue'
import Login from '../components/Account/Login.vue'
import NotFound from '../components/Shared/NotFoundPage.vue'
import Home from '../components/Home/Home.vue';
import Map from "../components/Map/Map.vue";
import Orders from "../components/Orders/Orders.vue";
import Drivers from "../components/Drivers/Drivers.vue";
import Company from "../components/Company/Company.vue";
import Managers from "../components/Company/Managers.vue";
import Vehicle from "../components/Vehicle/Vehicle.vue";
import Schedule from "../components/Schedule/Schedule.vue";
import Price from "../components/Price/Price.vue";
import ProfileDetails from "../components/Profile/ProfileDetails.vue";
import Dispatchers from "../components/Dispatchers/Dispatchers.vue";
import ScheduleReport from "../components/Report/ScheduleReport.vue";
import ResetPassword from "../components/Account/ResetPassword.vue";
import OrderReport from "../components/Report/OrderReport.vue";
import AverageReport from "../components/Report/AverageReport.vue";
import Configuration from "../components/Configuration/Configuration.vue";
import RateAndBugs from "../components/RateAndBugs/RateAndBugs.vue";
import ChangeMobileVersion from "../components/MobileVersion/ChangeMobileVersion.vue";
import VoucherHistory from "../components/Company/VoucherHistory.vue";
import Customer from "../components/Customer/Customer.vue";
import CourierRate from "../components/RateAndBugs/CourierRate.vue";
import DriversVacations from "../components/Schedule/DriversVacations.vue";
import VehicleCosts from "../components/Vehicle/VehicleCosts.vue";
import VehicleReport from "../components/Report/VehicleReport.vue";
import Tracking from "../components/Tracking/Tracking.vue";
import FreeMap from "../components/Map/FreeMap";
import TrackingFree from "../components/Map/TrackingFree.vue";
import CourierRates from "../components/RateAndBugs/CourierRates.vue";
import TestAI from "../components/TestAI/TestAI.vue";


const routes = [
    {
        path: '/login',
        component: Login,
        name: 'login',
        meta: {
            roles: [
                "ADMIN",
                "DEFAULT"
            ]
        }

    },
    {
        path: '/',
        component: MainView,
        redirect: '/maps',
        children: [
            {
                path: '/home',
                component: Home,
                name: 'home',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/maps',
                component: Map,
                name: 'maps',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/orders',
                component: Orders,
                name: 'orders',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/drivers',
                component: Drivers,
                name: 'drivers',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/companies',
                component: Company,
                name: 'company',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/managers',
                component: Managers,
                name: 'managers',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/vehicle',
                component: Vehicle,
                name: 'vehicle',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/schedule',
                component: Schedule,
                name: 'schedule',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/price-list',
                component: Price,
                name: 'price',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/profile',
                component: ProfileDetails,
                name: 'profile',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/dispatchers',
                component: Dispatchers,
                name: 'dispatchers',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/report-schedule',
                component: ScheduleReport,
                name: 'report-schedule',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/reset-password',
                component: ResetPassword,
                name: 'reset-password',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/order-report',
                component: OrderReport,
                name: 'order-report',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/average-report',
                component: AverageReport,
                name: 'average-report',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/configuration',
                component: Configuration,
                name: 'configuration',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/rate-and-bugs',
                component: RateAndBugs,
                name: 'rate-and-bugs',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/voucher-history',
                component: VoucherHistory,
                name: 'voucher-history',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/change-mobile-version',
                component: ChangeMobileVersion,
                name: 'change-mobile-version',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/customers',
                component: Customer,
                name: 'customers',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/tracking',
                component: Tracking,
                name: 'tracking',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/courier-rate',
                component: CourierRate,
                name: 'courier-rate',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/courier-rates',
                component: CourierRates,
                name: 'courier-rates',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/drivers-vacations',
                component: DriversVacations,
                name: 'drivers-vacations',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/vehicle-costs',
                component: VehicleCosts,
                name: 'vehicle-costs',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/vehicle-report',
                component: VehicleReport,
                name: 'vehicle-report',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
            {
                path: '/test-ai',
                component: TestAI,
                name: 'test-ai',
                meta: {
                    roles: [
                        "ADMIN",
                        "DEFAULT"
                    ]
                }
            },
        ]
    },
    {
        path:
        '*',
        component: NotFound,
    }
];

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes



// WEBPACK FOOTER //
// ./src/routes/routes.js